<template>
	<!-- 工作日报 -->
	<div>
		<div class="search_wrap">
			<el-form
				:model="queryParam"
				ref="form"
				label-width="80px"
				:inline="true"
				size="mini"
			>
				<el-form-item label="用户电话">
					<el-input
						@keyup.enter.native="searchQuery"
						v-model="queryParam.phone"
						placeholder="请输入"
					></el-input>
				</el-form-item>
				<div class="selectBox">
					<span class="selectText">关注情况</span>
					<el-select
						v-model="queryParam.type"
						size="mini"
						placeholder="请选择">
						<el-option label="请选择" value></el-option>
						<el-option label="微信登陆+关注公众号" value="1"></el-option>
						<el-option label="微信登陆+未关注公众号" value="2"></el-option>
						<el-option label="未微信登陆+关注公众号" value="3"></el-option>
					</el-select>
				</div>
				<el-form-item>
					<el-button type="primary" @click="searchQuery">查询</el-button>
					<el-button type="default" @click="searchReset">重置</el-button>
					<el-button type="primary" @click="getUserInfo" :disabled="userState"
						>批量获取用户基本信息</el-button
					>
					<el-button type="primary" @click="getOpenids" :disabled="openidsState"
						>拉取用户列表openid</el-button
					>
				</el-form-item>
			</el-form>
		</div>

		<e-table
			:listLoading="loading"
			:selection="true"
			:tableHeadConfig="columns"
			@pageChange="loadData"
			:paginationData="ipagination"
			:tableLoadData="dataSource"
			@selectLine="onSelectChange"
			:tableRowClassName="tableRowClassName"
		>
			<template #subscribeTime="slotData">
				<p>{{slotData.data.row.subscribeTime}}</p>
			</template>
		</e-table>
	</div>
</template>

<script>
import { httpAction } from '@/api/manage';
import eTable from '@/components/table';
import { listMixin } from '@/mixins/listMixin';
import { convertTime } from "@/utils/util";
export default {
	components: { eTable },
	mixins: [listMixin],
	data() {
		return {
			inspectionDate: '',
			dateDefaultShow: '',
			expireTimeOption: {
				disabledDate(date) {
					return date.getTime() >= Date.now();
				},
			},
			url: {
				list: '/user/info/queryPage',
				batchget: '/user/info/batchget',
				openids: '/user/info/fetch/openids',
			},
			//字段权限
			loading: false,
			queryParam: {},
			columns: [
				{ field: 'phone', label: '用户电话' },
				{ field: 'subscribeTime', label: '关注时间', slotName: 'subscribeTime', columnType: 'slot', },
				{ field: 'appletOpenid', label: '小程序openid' },
				{ field: 'openid', label: '公众号openid' },
				{ field: 'unionid', label: '公众号unionid' },
			],
			openidsState: false,
			userState: false,
		};
	},
	updated() {},
	mounted() {
		this.dataSource.forEach(item => item.subscribeTime && convertTime(item.subscribeTime));
		this.dateDefaultShow = new Date();
		this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
	},
	methods: {
		getUserInfo() {
			this.loading = true;
			this.userState = true;
			httpAction(this.url.batchget, {}, 'get').then((res) => {
				if (res.code == 200) {
					this.$message.success('批量获取用户基本信息成功');
					console.log(res.data);
					this.userState = false;
				} else {
					this.$message.error(res.message);
				}
				this.loading = false;
			});
		},
		getOpenids() {
			this.loading = true;
			this.userState = true;
			this.openidsState = true;
			httpAction(this.url.openids, {}, 'get').then((res) => {
				if (res.code == 200) {
					this.$message.success('拉取用户列表openid成功');
					console.log(res.data);
					this.userState = false;
					this.openidsState = false;
				} else {
					this.$message.error(res.message);
				}
				this.loading = false;
			});
		},
		dateChange(date) {
			this.queryParam.inspectionDateStart = date[0] + ' 00:00:00';
			this.queryParam.inspectionDateEnd = date[1] + ' 23:59:59';
		},
		clockwiseImg() {},
		searchReset() {
			this.queryParam = {};
			this.inspectionDate = '';
			this.searchQuery();
		},
	},
};
</script>

<style scoped lang="less">
.search_wrap {
	margin: 10px 0;
}

.selectBox {
	margin-bottom: 18px;
	display: inline-block;
	margin-right: 10px;
	vertical-align: top;
}
.selectText {
	width: 80px;
	line-height: 28px;
	font-weight: 700;
	cursor: default;
	float: none;
	display: inline-block;
	text-align: right;
	vertical-align: middle;
	font-size: 14px;
	color: #606266;
	padding: 0 12px 0 0;
	box-sizing: border-box;
}

.cursorStyle {
	cursor: pointer;
}

.images {
	display: none;
}
</style>
